<script setup lang="ts">
// COMPOSABLES
const { tt } = useTypedI18n();
const userGatedAction = useUserGatedActionState();

// DATA
const actionName = computed(() => {
    switch (userGatedAction.value?.action) {
        case UserGatedAction.ADP_BID:
        case UserGatedAction.MAKE_OFFER:
            return tt('login.gatedActions.makeAnOffer');
        case UserGatedAction.SDP_APPROVE:
            return tt('login.gatedActions.approve');
        case UserGatedAction.ADD_FAVORITE_ASSET:
            return tt('login.gatedActions.addToFavorites');
    }
});
</script>

<template>
    <div v-if="userGatedAction" class="bg-primary-500/25 ring-default flex flex-col self-stretch rounded-lg p-4 ring md:p-6">
        <p class="text-highlighted flex-1 text-sm font-semibold">{{ tt('login.gatedActions.title', { actionName: actionName }) }}</p>
        <p class="text-highlighted flex-1 text-sm">{{ tt('login.gatedActions.description') }}</p>
    </div>
</template>
